export default "__VITE_ASSET__DM6eEdLx__"